export default "__VITE_ASSET__CZmHjue7__"